import styled, { keyframes } from 'styled-components';

const dash = keyframes`
  0% {
    stroke-dashoffset: 1000;
  }
  100% {
    stroke-dashoffset: 0;
  }
`;

const dashCheck = keyframes`
  0% {
    stroke-dashoffset: -100;
  }
  100% {
    stroke-dashoffset: 900;
  }
`;

const dashLoading = keyframes`
  0% {
    stroke-dasharray: 3.1,620;
    stroke-dashoffset: 0;
  }
  50% {
    stroke-dasharray: 275.9,620;
    stroke-dashoffset: -108;
  }
  100% {
    stroke-dasharray: 275.9,620;
    stroke-dashoffset: -384;
  }
`;

export const Checkmark = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  
  svg {
    display: block;
    width: 90px;
    
    filter: drop-shadow(0 8px 15px rgba(30,182,255,0.24));
  }
  
  .loader-path {
    stroke-dasharray: 465,620;
    stroke-dashoffset: -10;
    animation: ${dashLoading} 1.5s ease-in-out infinite;
    stroke-linecap: round;
  }

  .path {
    stroke-dasharray: 1000;
    stroke-dashoffset: 0;
    
    &.circle {
      animation: ${dash} .9s ease-in-out;
    }
    
    &.line {
      stroke-dashoffset: 1000;
      animation: ${dash} .9s .35s ease-in-out forwards;
    }
    
    &.check {
      stroke-dashoffset: -100;
      animation: ${dashCheck} .9s .35s ease-in-out forwards;
    }
  }
`;
